import { IEntity } from "@interfaces/entity";
import { Customer } from "./customer";
import { User } from "./identity/user";

export class CustomerNote implements IEntity {
  id?: number;

  subject: string;
  content: string;

  author: string;
  //createdByUserId?: string;
  //createdByUser?: User;

  timestamp?: Date;

  customerId: number;
  customer?: Customer;

  entityName = "CustomerNote";

  constructor(formValue?: Partial<CustomerNote>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<CustomerNote>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
